module.exports = __webpack_public_path__ + "static/img/clickin1.e88f68ac.png";